/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteTimesheetEntryMutationResponse,
  DeleteTimesheetEntryPathParams,
  DeleteTimesheetEntryQueryParams,
} from '../models/DeleteTimesheetEntry.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteTimesheetEntryMutationResponseSchema } from '../zod/deleteTimesheetEntrySchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteTimesheetEntryMutationKey = () =>
  [{ url: '/api/entries/:id' }] as const;

export type DeleteTimesheetEntryMutationKey = ReturnType<
  typeof deleteTimesheetEntryMutationKey
>;

/**
 * {@link /api/entries/:id}
 */
export async function deleteTimesheetEntry(
  id: DeleteTimesheetEntryPathParams['id'],
  params?: DeleteTimesheetEntryQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteTimesheetEntryMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/entries/${id}`,
    params,
    ...requestConfig,
  });
  return deleteTimesheetEntryMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/entries/:id}
 */
export function useDeleteTimesheetEntry<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteTimesheetEntryMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: DeleteTimesheetEntryPathParams['id'];
        params?: DeleteTimesheetEntryQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteTimesheetEntryMutationKey();

  return useMutation<
    DeleteTimesheetEntryMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: DeleteTimesheetEntryPathParams['id'];
      params?: DeleteTimesheetEntryQueryParams;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, params }) => {
        return deleteTimesheetEntry(id, params, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
